import TatvamCheckbox from "./tatvamCheckbox";

export default TatvamCheckbox;
